export default __webpack_public_path__ + "static/media/arrow-drop-down.23e22897.svg";